(function () {
    'use strict';
    angular.module('app').controller('DriverDetailsController', DriverDetailsController);
    DriverDetailsController.$inject = [
        '$q',
        'FleetService',
        '$routeParams',
        'toastr',
        'ClientService',
        'ConfirmationModalFactory',
        '$window',
        '$timeout',
        'CropperModalService',
        'hasDuplicate',
        '$rootScope',
        'Upload',
        '$location'
    ];

    function DriverDetailsController(
        $q,
        FleetService,
        $routeParams,
        toastr,
        ClientService,
        ConfirmationModalFactory,
        $window,
        $timeout,
        CropperModalService,
        hasDuplicate,
        $rootScope,
        Upload,
        $location
    ) {
        const vm = this;
        const cropperModal = new CropperModalService();
        const { id, fleetId, driverGroupId, vehicleId } = $routeParams;
        const redirectBaseURL = {
            fleetId: '/fleets/details/',
            driverGroupId: '/fleets/driver-groups/details/',
            vehicleId: '/fleets/vehicles/details/'
        };
        const notAvailableOption = {
            name: 'N/A',
            id: null
        };
        const toActiveConf = new ConfirmationModalFactory({}, {
            message: 'messages.warning.statusChange.MESSAGE.TO_RECORD_ACTIVE',
            code: 'messages.warning.statusChange.CODE'
        });
        const toInactiveConf = new ConfirmationModalFactory({}, {
            message: 'messages.warning.statusChange.MESSAGE.TO_RECORD_INACTIVE',
            code: 'messages.warning.statusChange.CODE'
        });
        const deleteConf = new ConfirmationModalFactory({}, {
            message: 'messages.warning.statusChange.MESSAGE.DELETE_RECORD',
            code: 'messages.warning.statusChange.CODE'
        });
        const viewConfirmation = new ConfirmationModalFactory({}, {
            message: 'messages.warning.viewChange.MESSAGE',
            code: 'messages.warning.viewChange.CODE',
        });
        const onRouteChangeStart = $rootScope.$on('$routeChangeStart', (event, next) => {
            if (vm.driver && vm.driverRaw) {
                if (!angular.equals(cleanPayload(vm.driver), cleanPayload(vm.driverRaw))) {
                    viewConfirmation.getInstance().result.then(cond => {
                        if (cond) {
                            onRouteChangeStart();
                            let nextRoute = next.$$route.originalPath;
                            if (_.contains(next.$$route.originalPath), ':') {
                                nextRoute = nextRoute.split(':')[0];
                            }
                            $location.path(nextRoute);
                        }
                    });
                    event.preventDefault();
                }
            }
        });

        vm.shipmentTypes = [
            { value: 'regular', label: 'Regular shipment' },
            { value: 'returns', label: 'Returns Shipments' },
            { value: 'both', label: 'Regular and Returns Shipments' }
        ];
        vm.jobTypes = [
            { value: 'pickuponly', label: 'Pickup only' },
            { value: 'p2p', label: 'P2P' },
            { value: 'delivery', label: 'Delivery' }
        ];
        vm.licenseDimension = { width: 1200, height: 1200 };
        vm.driverDimension = { width: 1200, height: 1200 };

        vm.searchRoutes = searchRoutes;
        vm.searchDriverGroups = searchDriverGroups;
        vm.searchCompanies = searchCompanies;
        vm.searchFleets = searchFleets;
        vm.deleteDriver = deleteDriver;
        vm.changeStatus = changeStatus;
        vm.deleteDriver = deleteDriver;
        vm.openCropper = openCropper;
        vm.saveDriver = saveDriver;
        vm.searchVehicle = searchVehicle;
        vm.isUnique = isUnique;
        vm.goBack = goBack;

        init();

        function init() {
            vm.id = $routeParams.id;
            if (vm.id) {
                $q.all([getDriverDetails(), getAvailableCompanies()]).then(data => {
                    vm.driver = data[0];
                    vm.driver.availableShipmentTypes = getDriverAvailableShipmentTypes();
                    vm.driver.company = getDriverCompany(data[1]);
                    vm.driver.availableJobTypes = getDriverJobTypes();
                    vm.driverRaw = angular.copy(vm.driver); // save an original copy of the driver data
                });
            }
        }

        function getDriverAvailableShipmentTypes() {
            return vm.shipmentTypes.filter(item => vm.driver.availableShipmentTypes.indexOf(item.value) !== -1);
        }

        function getDriverCompany(companies) {
            return companies.find(item => item.id === Number(vm.driver.companyId));
        }

        function getDriverJobTypes() {
            return vm.jobTypes.filter(item => vm.driver.availableJobTypes.indexOf(item.value) !== -1);
        }

        function getDriverDetails() {
            const defer = $q.defer();
            FleetService.Drivers.get(vm.id, data => {
                defer.resolve(data);
            }, error => {
                toastr.error('Driver not found', error.message);
                defer.reject(error);
            });
            return defer.promise;
        }

        function searchRoutes(select) {
            if (!select.open) {
                return false;
            }

            vm.searching = true;
            vm.routes = [];
            FleetService.Routes.getRoutes(data => {
                vm.routes = data.content;
                vm.searching = false;
            }, error => {
                vm.searching = false;
                toastr.error('Unable to search for route', error.message);
            }, { name: select.search });
        }

        function searchDriverGroups(select) {
            if (!select.open) {
                return false;
            }

            vm.searching = true;
            vm.driverGroups = [];
            FleetService.DriverGroups.getAll(data => {
                vm.driverGroups = [notAvailableOption, ...data.content];
                vm.searching = false;
            }, error => {
                vm.searching = true;
                toastr.error('Unable to search for vehicle types', error.message);
            }, {
                name: select.search
            })
        }

        function searchCompanies(select) {
            if (!select.open) {
                return false;
            }

            vm.searching = true;
            getAvailableCompanies().then(data => {
                vm.availableCompanies = data;
                vm.searching = false;
            }, error => {
                vm.searching = false;
            });
        }

        function getAvailableCompanies() {
            const defer = $q.defer();
            ClientService.Client.getAvailableCompany(data => {
                defer.resolve(data);
            }, error => {
                toastr.error(error.message);
                defer.reject(error);
            });
            return defer.promise;
        }

        function searchFleets(select) {
            if (!select.open) {
                return false;
            }

            vm.searching = true;
            FleetService.Fleets.getAll(data => {
                vm.fleets = [notAvailableOption, ...data.content];
                vm.searching = false;
            }, error => {
                vm.searching = false;
                toastr.error('Unable to search for vehicle types', error.message);
            }, { name: select.search });
        }

        function searchVehicle(select) {
            if (!select.open)
                return false;
            vm.searching = true;
            vm.vehicles = [];
            FleetService.Vehicles.getAll(data => {
                vm.vehicles = [notAvailableOption, ...data.content];
                vm.searching = false;
            }, error => {
                vm.searching = true;
                toastr.error('Unable to search for vehicle', error.message);
            }, {
                plateNumber: select.search,
                hasDriver: false
            })
        }

        function deleteDriver(driver) {
            deleteConf.getInstance().result.then(cond => {
                if (cond) {
                    FleetService.Drivers.delete(driver.id, data => {
                        toastr.success('Fleet successfully deleted');
                        $location.path('fleets/drivers');
                    }, error => {
                        toastr.error('Unable to do request. Please try again later', error.message);
                    });
                }
            });
        }

        function changeStatus(event) {
            event.preventDefault();
            if (vm.driver.active) {
                vm.driver.active = false;
                toActiveConf.getInstance().result.then(cond => {
                    if (cond) {
                        $timeout(() => {
                            vm.driver.active = true;
                        });
                    }
                });
            } else {
                vm.driver.active = true;
                toInactiveConf.getInstance().result.then(cond => {
                    if (cond) {
                        $timeout(() => {
                            vm.driver.active = false;
                        });
                    }
                });
            }
        }

        function openCropper(load, fieldName) {
            cropperModal.setImageFile(load);
            cropperModal.getInstance().result.then(newImage => {
                vm[fieldName] = cropperModal.dataURItoBlob(newImage, load.$ngfName);
            });
        }

        function saveDriver(form) {
            form.$setSubmitted();
            if (form.$invalid) {
                return false;
            }
            vm.saveInProgress = true;

            $q.all({
                vehiclePhoto: upload(vm.croppedDriverPhoto || vm.driverPhoto, 'driverPhotoUrl', true),
                plateNoPhoto: upload(vm.croppedLicenseNo || vm.licensePhoto, 'licensePhotoUrl', false)
            }).finally(data => {
                if ($routeParams.id) {
                    const payload = cleanPayload(vm.driver);
                    FleetService.Drivers.update(vm.id, payload, result => {
                        vm.saveInProgress = false;
                        toastr.success('Driver successfully updated');
                        init();
                    }, error => {
                        vm.saveInProgress = false;
                        toastr.error(error.message);
                    });
                } else {
                    FleetService.Drivers.create(cleanPayload(vm.driver), result => {
                        vm.saveInProgress = false;
                        toastr.success('Driver successfully updated.');
                        if (fleetId) {
                            $location.path(redirectBaseURL.fleetId + fleetId);
                        } else if (driverGroupId) {
                            $location.path(redirectBaseURL.typeId + typeId);
                        } else {
                            $location.path('fleets/drivers/details/' + result.id);
                        }
                    }, error => {
                        vm.saveInProgress = false;
                        toastr.error(error.message);
                    });
                }
            });
        }

        function upload(file, field, isDriverPhoto) {
            const defer = $q.defer();
            if (!file) {
                $timeout(() => {
                    defer.resolve(null);
                });
            } else {
                vm[field + 'Uploading'] = true;
                Upload.resize(file, { width: 600, height: 600 }).then(resizedFile => {
                    FleetService.Drivers.upload(resizedFile, data => {
                        vm.driver[field] = data;
                        vm[field + 'Uploading'] = false;
                        defer.resolve();
                    }, err => {
                        vm[field + 'Uploading'] = false;
                        toastr.error('Unable to upload photo', err.messsage);
                        defer.resolve();
                    }, { isDriverPhoto })
                });
            }
            return defer.promise;
        }

        function cleanPayload(payload) {
            return {
                active: payload.active,
                addressLine1: payload.addressLine1,
                addressLine2: payload.addressLine2,
                companyId: payload.company.id,
                driverGroupId: angular.getObjVal(payload, 'driverGroup.id'),
                driverId: payload.driverId,
                driverPhotoUrl: payload.driverPhotoUrl,
                email: payload.email,
                firstName: payload.firstName,
                fleetId: angular.getObjVal(payload, 'fleet.id'),
                jobTypeIds: payload.availableJobTypes.map(item => item.value),
                lastName: payload.lastName,
                latitude: payload.latitude,
                licenseNumber: payload.licenseNumber,
                licensePhotoUrl: payload.licensePhotoUrl,
                location: payload.location.id,
                longitude: payload.longitude,
                officeId: payload.officeId,
                phone1: payload.phone1,
                phone2: payload.phone2,
                vehicleId: angular.getObjVal(payload, 'currentVehicle.id') || 0,
                routeIds: payload.routes.map(item => item.id),
                shipmentTypes: payload.availableShipmentTypes.map(item => item.value)
            }
        }

        function isUnique(model, field) {
            vm.checkingDups = true;
            hasDuplicate({
                serviceCallback: FleetService.Drivers.getAll,
                callbackFormat: ['success', 'error', 'filter'],
                findBy: 'content',
                compareWith: model,
                compareBy: field,
                raw: angular.getObjVal(vm, 'driverRaw.' + field),
                filters: {
                    size: 2,
                    page: 0,
                    sort: 'id,desc',
                    [field]: model
                }
            }).then(res => {
                vm[field + 'Error'] = res ? field === 'driverId' ? 'Driver ID is already taken' : 'Licence number is already taken' : null;
                vm.checkingDups = false;
            }).catch(err => {
                vm.checkingDups = false;
            });
        }

        function goBack() {
            $window.history.back();
        }
    }
})()



// WEBPACK FOOTER //
// ./js/controllers/fleets/DriverDetailsController.js